import { SectionDto, SectionUpdateDto } from 'models/dtoTypes';
import { getQuestionnaireApi } from 'services';
import { ErrorHandler, handleError } from './openapiClient';

export const GetUnsatisfiedSections = async (
  companyId: string,
): Promise<SectionDto[]> => {
  const client = await getQuestionnaireApi();
  const response = await client.getUnsatisfiedSections(companyId);
  return response?.data;
};

export const UpdateSmartGovernanceScore = async (
  alias: string,
  requestBody: SectionUpdateDto,
) => {
  const client = await getQuestionnaireApi();
  const response = await client.updateSmartGovernanceScore(alias, requestBody);
  return response?.data;
};

export const SubmitWomeCompany = async (
  alias: string,
  requestBody: SectionUpdateDto,
) => {
  const client = await getQuestionnaireApi();
  const response = await client.submitWomeCompany(alias, requestBody);
  return response?.data;
};


export const GetSection = async (alias: string, companyId?: string) => {
  try {
    const client = await getQuestionnaireApi();
    const response = await client.getSection(alias, companyId);
    return response;
  } catch(e) {
    handleError(e);
  }
};


export const GetAllSections = async (companyId?: string, errorHandler?: ErrorHandler) => {
  try {
    const client = await getQuestionnaireApi();
    const response = await client.getAllSections(companyId);
    return response;
  } catch(e) {
    handleError(e, errorHandler);
  }
};

export const CreateOrUpdateResponse = async (
  parameter: {
    alias: string, // path param
    updateScore: boolean, // query param
    markInformationSeen?: boolean,
  },
  requestBody: SectionUpdateDto,
  errorHandler?: ErrorHandler
) => {
  try {
    const client = await getQuestionnaireApi();
    const { alias, updateScore, markInformationSeen } = parameter;
    const response = await client.createOrUpdateResponse(alias, updateScore, markInformationSeen, requestBody);
    return response;
  } catch(e) {
    handleError(e, errorHandler);
  }
};